export default __webpack_public_path__ + "static/media/aPadBanner.bcb5aae6.webp";